import React from 'react'
import AnonymousView from '../anonymous-view'

const AnonymousViewNl = () => {
    return <AnonymousView languageCode="nl" />
}

export default AnonymousViewNl
